import superagent from 'superagent'

export const markerTypes35Set = markerTypes => ({
  type: 'MARKER_TYPES_SET',
  payload: markerTypes
})

// No short-circuit on existing state: this slice is persisted to IndexedDB via
// redux-persist, so a cached read here means marker type changes never reach a
// browser that has loaded the app before. Matches marker-types-25/105.
export const markerTypes35FetchRequest = () => (dispatch, getState, token) => {
  return new Promise(resolve => {
    superagent
      .get(`${__API_URI_2__}/markertype/get?activity=255&folder=small35`)
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (!res) return resolve(null)
        if (err) {
          if (err.status == 401) {
            return resolve(err.status)
          }
          return resolve(null)
        }
        dispatch(markerTypes35Set(res.body))
        resolve(res.body)
      })
  })
}
